<template>
  <div class="section pt-0">
    <div class="textTab mt-30 mb-20">
      <p class="is-size-6 has-text-weight-bold">10 dernières opportunités en cours</p>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table
      url="" ref="tableOpportunite"
      :data="mesOpportunites"
      :columns="columns"
      :options="options"
      class="is-hidden-mobile"
      @loaded="finLoading"
      @loading="debutLoading"
      @error="erreur">
      <div slot="dateCreation" slot-scope="props">
       {{props.row.date}}
      </div>
      <div slot="dateValidite" slot-scope="props">
       {{props.row.dateDeValidite}}
      </div>
      <div slot="devisNum" slot-scope="props" v-if="props.row.data.devisObject">
        {{props.row.data.devisObject.code}}
      </div>
      <div slot="voir" slot-scope="props" style="cursor: pointer;">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="$router.push({ name: 'detailopportunite', params: {id: props.row.id}})">
          <b-icon icon="file-find" type="is-primary"/>
        </b-button>
      </div>
      <div slot="portail" slot-scope="props" v-if="props.row.previewLink != null">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="ouvrirNouvelleFenetre(props.row.permalink)">
          <b-icon icon="open-in-new" type="is-primary"/>
        </b-button>
      </div>
      <div slot="envoyer" slot-scope="props">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="envoyerPdf(props.row)">
          <b-icon icon="file-send" type="is-primary"/>
        </b-button>
      </div>
      <div slot="telecharger" slot-scope="props">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="exporterPdf(props.row)">
          <b-icon icon="file-pdf" type="is-danger"/>
        </b-button>
      </div>
      <div slot="modifier" slot-scope="props">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="rechargerOpportunite(props.row, true)"
          :disabled="props.row.data.valider">
          <b-icon
            icon="square-edit-outline"
            :type="props.row.data.valider ? '' : 'is-success'"/>
        </b-button>
      </div>
      <div slot="supprimer" slot-scope="props">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="supprimerOpportunite(props.row)">
          <b-icon
            icon="delete-forever"
            type="is-danger"/>
        </b-button>
      </div>
    </v-server-table>
    <b-modal v-model="isComponentCopierOpportunite"
             has-modal-card class="modal">
      <app-copier-opportunite :opportuniteId="opportuniteId" :type="type"
        @close="isComponentCopierOpportunite = false"/>
    </b-modal>
    <b-modal v-model="isComponentOuvrirEnvoiMail"
             has-modal-card class="modal"
             :disabled="true">
      <app-envoi-mail
        :opportunite-id="opportuniteId"
        :opportunite-contact="opportuniteContact"
        :opportunite-client-id="opportuniteClientId"
        :afficher-recap="afficherRecap"
        :permalink="permalink"/>
    </b-modal>
    <b-modal v-model="isComponentConfirmationMail"
             has-modal-card class="modal">
      <app-confirmation-mail/>
    </b-modal>
    <b-modal v-model="isComponentSupprimerOpportunite"
             has-modal-card class="modal">
      <app-supprimer-opportunite
        :messageError="messages"
        :errorPopup="error"
        @close="isComponentSupprimerOpportunite = false"
        @yes="closeModalSuppression"/>
    </b-modal>
    <div class="card is-hidden-tablet mb-10" v-for="(opportunite, i) in opportunitesMobile"
      :key="i">
      <div class="card-content">
        <div class="level is-mobile mb-0">
          <div class="level-left">
            <p class="has-text-weight-bold">
              {{opportunite.annonceur}}
            </p>
          </div>
          <div class="level-right">
            <div class="level-item">
              <b-dropdown class="mt-10" arial-role="menu">
                <a role="button" type="is-light" slot="trigger">
                  <b-icon icon="dots-vertical"/>
                </a>
                <div class="dropdown-item" aria-role="menuitem"
                  @click="ouvrirNouvelleFenetre(opportunite.previewLink)">
                  <b-icon icon="open-in-new" type="is-primary"/>
                  Ouvrir
                </div>
                <div class="dropdown-item" aria-role="menuitem"
                  @click="rechargerOpportunite(opportunite)">
                  <b-icon icon="subdirectory-arrow-left" type="is-primary"/>
                  Recharger
                </div>
              </b-dropdown>
            </div>
          </div>
        </div>
        {{opportunite.themeCampagne}}
        <br>
        {{opportunite.dateDeValidite}}
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import router from '@/router';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import HTTP from '@/api/HTTP';
import EnvoiMail from '@/components/creationOpportunite/panier/envoyerOpportunite/envoiMail';
import confirmationMail from '@/components/creationOpportunite/panier/envoyerOpportunite/confirmationMail';
import { supprime } from '@/api/opportunite/index';
import gestionErreur from '@/services/general/gestionErreur';
import supprimerOpportunite from '@/components/mesOpportunites/supprimerOpportunite';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import { SET_IS_MODIF } from '@/store/creationOpportunite/panier-mutation-type';
import { DeleteDevis } from '@/api/devis/index';
import validationDevis from '@/services/devis/validation';
import copierOpportunite from '../mesOpportunites/recherche/copierOpportunite';

const Opportunites = createNamespacedHelpers('opportunites');
const Panier = createNamespacedHelpers('panier');
const Modal = createNamespacedHelpers('modal');
const User = createNamespacedHelpers('user');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  components: {
    appEnvoiMail: EnvoiMail,
    appConfirmationMail: confirmationMail,
    appCopierOpportunite: copierOpportunite,
    appSupprimerOpportunite: supprimerOpportunite,
  },
  data() {
    return {
      trad: {
        userId: '↑↓ Commercial(e)',
        date: '↑↓ Création',
        annonceur: 'Client',
        themeCampagne: '↑↓ Thème de la campagne',
        dateValidite: '↑↓ Validité',
        devisNum: 'N° de Devis',
        envoyer: 'Envoyer',
        telecharger: 'PDF',
        supprimer: 'Supprimer',
      },
      opportuniteId: null,
      opportuniteContact: null,
      afficherRecap: null,
      permalink: null,
      isComponentCopierOpportunite: false,
      isComponentSupprimerOpportunite: false,
      searchQuery: {},
      type: '',
      opportuniteClientId: null,
      devisOpportuniteId: null,
      messages: [],
      error: false,
      codeDevis: '',
    };
  },
  computed: {
    ...Opportunites.mapGetters({
      mesOpportunites: 'mesOpportunites',
      totalOpportunites: 'totalOpportunites',
      detailOpportunite: 'detailOpportunite',
    }),
    ...Panier.mapGetters({
      panier: 'panier',
    }),
    ...User.mapGetters({
      hasPortailAnnonceur: 'hasPortailAnnonceur',
      currentIdentifiantUser: 'identifiantUser',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    ...Modal.mapGetters({
      getIsComponentOuvrirEnvoiMail: 'isComponentOuvrirEnvoiMail',
      getIsComponentConfirmationMail: 'isComponentConfirmationMail',
    }),
    isComponentConfirmationMail: {
      get() {
        return this.getIsComponentConfirmationMail;
      },
      set(value) {
        this.setIsComponentConfirmationMail(value);
      },
    },
    isComponentOuvrirEnvoiMail: {
      get() {
        return this.getIsComponentOuvrirEnvoiMail;
      },
      set(value) {
        this.setIsComponentOuvrirMail(value);
      },
    },
    columns() {
      return [
        { column: 'userId', view: true },
        { column: 'dateCreation', view: true },
        { column: 'annonceur', view: true },
        { column: 'themeCampagne', view: true },
        { column: 'dateValidite', view: true },
        { column: 'devisNum', view: this.isAffixe2 },
        { column: 'voir', view: true },
        { column: 'portail', view: this.hasPortailAnnonceur },
        { column: 'envoyer', view: true },
        { column: 'telecharger', view: true },
        { column: 'modifier', view: true },
        { column: 'supprimer', view: true },
      ].filter(c => c.view).map(c => c.column);
    },
    options() {
      const that = this;
      return {
        headings: {
          annonceur: this.trad.annonceur,
          dateCreation: this.trad.date,
          themeCampagne: this.trad.themeCampagne,
          dateValidite: this.trad.dateValidite,
          userId: this.trad.userId,
          devisNum: this.trad.devisNum,
        },
        perPageValues: PER_PAGE_VALUE,
        perPage: 10,
        columnsClasses: {
          userId: 'colonneRechercheOpportuniteAnnonceur ellipsis',
          dateCreation: 'colonneBoutonOpportunite ellipsis',
          annonceur: 'colonneRechercheOpportuniteAnnonceur ellipsis',
          themeCampagne: 'colonneRechercheOpportuniteThemeCampagne ellipsis',
          dateValidite: 'colonneBoutonOpportunite ellipsis',
          voir: 'has-text-centered',
          portail: 'has-text-centered',
          envoyer: 'has-text-centered',
          telecharger: 'has-text-centered',
          modifier: 'has-text-centered',
          supprimer: 'has-text-centered',
        },
        texts: TEXTS,
        debounce: 600,
        initFilters: { userId: '' },
        filterByColumn: true,
        filterable: [
          { column: 'userId', view: true },
          { column: 'annonceur', view: true },
          { column: 'themeCampagne', view: true },
          { column: 'devisNum', view: this.isAffixe2 },
        ].filter(c => c.view).map(c => c.column),
        sortable: ['dateCreation', 'dateValidite', 'themeCampagne'],
        requestFunction: ((data) => {
          that.searchQuery = data.query;
          if (!data.query.userId) data.query.userId = this.currentIdentifiantUser;
          return this.actionsRechercheMesOpportunites({
            userId: this.currentIdentifiantUser,
            data,
          });
        }),
        responseAdapter: ((result) => {
          let data = result;
          if (this.searchQuery.userId) {
            data = data.filter((el) => String(el.userId).toLowerCase()
              .includes(String(this.searchQuery.userId).toLowerCase()),
            );
          }
          return {
            data: data,
            count: 10,
          };
        }),
      };
    },
    opportunitesMobile() {
      return this.mesOpportunites.slice(0, 10);
    },
  },
  methods: {
    ...Modal.mapMutations({
      setIsComponentOuvrirMail: typesModal.SET_IS_COMPONENT_OUVRIR_MAIL,
      setIsComponentConfirmationMail: typesModal.SET_IS_COMPONENT_CONFIRMATION_MAIL,
    }),
    ...Panier.mapMutations({
      actionsSetIsModif: SET_IS_MODIF,
    }),
    ...Opportunites.mapActions({
      actionsRechercheMesOpportunites: 'rechercheMesOpportunites',
    }),
    ...Panier.mapActions({
      actionsRechargerOpportunite: 'rechargerOpportunite',
    }),
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open({ container: null });
    },
    finLoading() {
      this.loadingComponent.close();
    },
    erreur(e) {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      gestionErreur('Erreur sur le tableau des opportunités', e);
    },
    ouvrirNouvelleFenetre(lien) {
      window.open(lien);
    },
    envoyerPdf(props) {
      this.permalink = props.permalink;
      this.opportuniteId = props.id;
      this.afficherRecap = props.afficherRecap;
      this.opportuniteContact = props.data.contact;
      this.opportuniteClientId = props.annonceurGuid ? props.annonceurGuid : props.annonceurId;
      this.isComponentOuvrirEnvoiMail = true;
    },
    exporterPdf(data) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      HTTP.get(data.url,
        { responseType: 'blob' },
      ).then((response) => {
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur(`Erreur lors de la generation du PDF de l'opportunite id: ${data.id}`, e);
        loadingComponent.close();
      });
    },
    async rechargerOpportunite(props, isModif) {
      if (this.panier.produits.panneauxLc.length ||
        this.panier.produits.reseauxTempo.length ||
        this.panier.produits.reseauxLc.length ||
        this.panier.produits.reseauxPersonnalise.length) {
        this.opportuniteId = props.id;
        this.type = 'modif';
        this.isComponentCopierOpportunite = true;
      } else {
        if (isModif) this.actionsSetIsModif(isModif);
        const loadingComponent = this.$buefy.loading.open({ container: null });
        await this.actionsRechargerOpportunite(props.id);
        loadingComponent.close();
        router.push('/panier');
      }
    },
    async closeModalSuppression() {
      this.debutLoading();
      try {
        if (this.devisOpportuniteId) {
          await DeleteDevis(this.devisOpportuniteId);
        }
        await supprime(this.opportuniteId);
        await this.getOpp();
        this.isComponentSupprimerOpportunite = false;
        this.finLoading();
      } catch (e) {
        this.finLoading();
        if (e.response && e.response.data.error) {
          validationDevis(
            e.response,
            this.messages,
            this.codeDevis);
          this.error = true;
        } else {
          gestionErreur('Erreur lors de la suppression de l\'opportunité');
        }
      }
    },
    supprimerOpportunite(props) {
      this.devisOpportuniteId = null;
      if (props.data.devisObject) {
        this.devisOpportuniteId = props.data.devisObject.id;
        this.codeDevis = props.data.devisObject.code;
      }
      if (props.id) {
        this.opportuniteId = props.id;
        this.isComponentSupprimerOpportunite = true;
      }
      this.messages = [];
      this.error = false;
    },
    async getOpp() {
      this.$refs.tableOpportunite.refresh();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableauDeBord/tableauOpportunites.vue